module.exports = __webpack_public_path__ + "img/explorer.3285d886.png";